export const API_ID = process.env.RAZZLE_ALGOLIA_API_APP_ID;
export const API_KEY = process.env.RAZZLE_ALGOLIA_API_SEARCH_KEY;
